import React, { Component } from 'react';
import { Table, Row, Col, InputNumber, Button, DatePicker, message, Spin } from 'antd';
import moment from 'moment';
import { data3_2_1 } from './data';
import imgSave from "../../saveImg";
import Auth from "../../Auth";
import TableText from "../../TableText";

const { MonthPicker } = DatePicker;

Number.prototype.toFixed = function (exponent) {
    if (this > 0) {
        return parseInt(this * Math.pow(10, exponent) + 0.5) / Math.pow(10, exponent);
    } else {
        return parseInt(this * Math.pow(10, exponent) - 0.5) / Math.pow(10, exponent);
    }
}

class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: moment().subtract(1, 'month').format('YYYY-MM'),
            data: [],
            loading: true,
            loadingSave: false,
            print: false
        }
    }


    componentDidMount() {
        this.getDateData(this.state.date);
    }



    computeNum = (data) => {
        const numConvert = (num = 0) => {
            num = Number(num || "0")
            return num
        };

        const totalName = ['actual', 'budget'];
        totalName.forEach(name => {
            data[12][name] = data.reduce((a, b, i) => {
                if (i != 12) {
                    a += numConvert(b[name]);
                }
                return a
            }, 0).toFixed(2);
        });

        data.forEach((item, i) => {
            data[i].var = (numConvert(data[i].actual) - numConvert(data[i].budget)).toFixed(2);
            data[i].completion = numConvert(data[i].budget) == 0 ? 0 : (numConvert(data[i].actual) / numConvert(data[i].budget)).toFixed(2);
        });

        console.log(data);
        this.setState({ data });

    }
    onChange = (name, value, i) => {
        let data = this.state.data;
        data[i][name] = value;

        this.computeNum(data);
    }

    getDateData = async (date) => {
        const dataBegin = JSON.stringify(data3_2_1);
        let data = JSON.parse(dataBegin);

        fetch(`/_2_8new_info?year=${moment(date).format('YYYY')}&month=null`, { credentials: 'include' }).then(x => x.json()).then(x => {
            if (x.data && x.data.length > 0) {
                data = x.data;
            }

            this.setState({ loading: false });
            this.computeNum(data);
        }).catch(err => {
            this.setState({ loading: false });
            console.error(err);
        })
    }

    onSave = () => {
        this.setState({ loadingSave: true });
        let date = this.state.date;
        if (!date) {
            message.error('请选择年份月份');
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            return
        }
        let year = moment(date).format("YYYY");
        let month = moment(date).format("M");
        let data = this.state.data.map(x => ({ ...x, year, }));
        // if (!data.every(x => x.name)) {
        //     message.error('名称不能为空，请到3-1-1设置名称！');
        //     return
        // }
        let dataFrom = new FormData();
        dataFrom.append('data', JSON.stringify(data));
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }
        fetch('/add_2_8new', headres).then(x => x.json()).then(x => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            if (x.status == 1) {
                message.success(x.msg);
                if (!data[0].id) {
                    this.getDateData(this.state.date);
                }
                return
            }
            message.error(x.msg);
        }).catch(err => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            console.error(err);
            message.error('保存失败' + JSON.stringify(err));
        })
    }

    downloadSG = () => {

        this.setState({ print: true, loading: true }, () => {
            imgSave('table3_2_1', 1.5, '3.20', this.state.date).then(x => {
                if (x.status == 1) {
                    message.info('添加成功！');
                } else {
                    message.error('添加失败' + x.msg);
                }

                this.setState({
                    print: false,
                    loading: false
                });
            }).catch(err => {
                console.error(err);
                this.setState({
                    print: false,
                    loading: false
                });
            })

        });

    }

    render() {
        const data = this.state.data;
        const columns = [{
            title: 'Month 月份',
            dataIndex: 'name',
            key: 'name',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                return (
                    <div className={`table-padding`} style={{ textAlign: "left" }}>
                        {text}
                    </div>
                )
            }
        }, {
            title: 'Current Year Actual 本年实际',
            dataIndex: 'actual',
            key: 'actual',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const title = ['Current Year Actual 本年实际'];
                const props = {
                    index,
                    key: 'actual',
                    title,
                    sqlName: "_2_8new",
                    name: 'actual',
                    type: index == 12 ? 'number' : 'inputNumber',
                    text,
                    onChange: this.onChange,
                };

                return <TableText
                    data={{ ...props }}
                />
            }
        }, {
            title: 'Current Year Target 本年预算/目标',
            dataIndex: 'budget',
            key: 'budget',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const title = ['Current Year Target 本年预算/目标'];
                const props = {
                    index,
                    name: 'budget',
                    title,
                    sqlName: "_2_8new",
                    type: index == 12 ? 'number' : 'inputNumber',
                    text,
                    onChange: this.onChange,
                };

                return <TableText
                    data={{ ...props }}
                />
            }
        }, {
            title: 'Variance - Actual Vs Budget 差异',
            dataIndex: 'var',
            key: 'var',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const title = ['Variance - Actual Vs Budget 差异'];
                const props = {
                    index,
                    name: 'var',
                    title,
                    sqlName: "_2_8new",
                    type: 'number',
                    text,
                    onChange: this.onChange,
                };

                return <TableText
                    data={{ ...props }}
                />
            }
        }, {
            title: 'Completion % 完成百分比',
            dataIndex: 'completion',
            key: 'completion',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const title = ['Completion % 完成百分比'];
                const props = {
                    index,
                    name: 'completion',
                    title,
                    sqlName: "_2_8new",
                    type: 'percent',
                    text,
                    onChange: this.onChange,
                };

                return <TableText
                    data={{ ...props }}
                />
            }
        }];

        return (
            <Spin spinning={this.state.loading}>
                <div className="table7_1_1">
                    <Row className="title" id="table3_2_1"  >
                        <Row>3.2 Wyndham Rewards Enrollment 温德姆奖赏计划新会员加入</Row>
                        <Row className="table-month">
                            <MonthPicker
                                placeholder="请选择年月"
                                monthCellContentRender={(date, local) => {
                                    return moment(date).format('M月')
                                }}
                                defaultValue={moment(this.state.date, 'YYYY-MM')}
                                format="YYYY-MM"
                                onChange={(date, str) => {
                                    this.setState({
                                        date: str,
                                        data: [],
                                        loading: true
                                    });
                                    this.getDateData(str)
                                }}
                            />
                        </Row>
                        <Table
                            columns={columns}
                            dataSource={data}
                            size="middle"
                            bordered
                            pagination={false}
                            className="content"
                            scroll={this.state.print ? {} : { y: 500 }}
                            rowKey={(record, index) => index}
                        />

                    </Row>
                    <Auth loading={this.state.loading} auth="edit_2_8">
                        <Row className="table-footer-btn">
                            <Button
                                type="primary"
                                style={{ marginRight: 10 }}
                                onClick={this.downloadSG}
                                loading={this.state.print}
                            >加入pdf</Button>
                            <Button
                                type="primary"
                                onClick={this.onSave}
                                loading={this.state.loadingSave}
                            >保存</Button>
                        </Row>
                    </Auth>

                </div>
            </Spin >
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/2-Analysis/2-8/index.js